let serializationOptions: { includeAttributes?: boolean } = {
  includeAttributes: true,
}

export function shouldIncludeAttributes(): boolean {
  return Boolean(serializationOptions.includeAttributes)
}

export function withMarkdownSerializationOptions<T>(
  options: { includeAttributes?: boolean } | undefined,
  fn: () => T,
): T {
  const prev = serializationOptions
  serializationOptions = options ?? {}
  try {
    return fn()
  } finally {
    serializationOptions = prev
  }
}
